namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd5Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd5';
    }
}
